<div class="row bloccodati">
  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Tipo indagine preliminare'"
       [valueInput]="ctxBodyFascicolo.fascicolo.tipoIndaginePreliminare ? ctxBodyFascicolo.fascicolo.tipoIndaginePreliminare.label : ''"></div>

</div>
<!-- <div *ngIf="ctxBodyFascicolo.fascicolo.definito" class="row container_fieldset bloccodati">
  <div class="col-sm-12">
  <fieldset class="form-group">
    <legend>Definizione fascicolo</legend>
    <div labelTextInput class="col-sm-4" [typeLabel]="'boolean'"
         [labelInput]="'Definito'" [valueInput]="ctxBodyFascicolo.fascicolo.definito"></div>
    <div labelTextInput class="col-sm-4" [typeLabel]="'date'"
         [labelInput]="'Data definizione'" [valueInput]="ctxBodyFascicolo.fascicolo.dataDefinizione"></div>
    <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
         [labelInput]="'Motivo definizione'"	[valueInput]="ctxBodyFascicolo.fascicolo.motivoDefinizione.label"></div>
  </fieldset>
 </div>
</div> -->
<div class="row container_fieldset">
 <div class="col-sm-12">
  <fieldset class="form-group">
    <legend>Giudici</legend>
    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Giudice indagini preliminari (G.I.P.)'"
         [valueInput]="ctxBodyFascicolo.fascicolo.giudiceIndaginiPreliminari"></div>
    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Giudice udienza preliminare (G.U.P.)'"
         [valueInput]="ctxBodyFascicolo.fascicolo.giudiceUdienzaPreliminare"></div>
    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Pubblico Ministero (P.M.)'"
         [valueInput]="ctxBodyFascicolo.fascicolo.pubblicoMinistero"></div>
  </fieldset>
 </div>
</div>
<div class="row container_fieldset">
 <div class="col-sm-12">
  <fieldset class="form-group">
    <legend>Incidente probatorio</legend>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
         [labelInput]="'Incidente probatorio'" [valueInput]="ctxBodyFascicolo.fascicolo.incidenteProbatorio"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
         [labelInput]="'Richiesta archiviazione al G.I.P'" [valueInput]="ctxBodyFascicolo.fascicolo.richiestaArchiviazione"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
         [labelInput]="'Data richiesta archiviazione'" [valueInput]="ctxBodyFascicolo.fascicolo.dataRichiestaArchiviazione"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
         [labelInput]="'Ulteriori indagini PM'" [valueInput]="ctxBodyFascicolo.fascicolo.rimandoAlPM"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
         [labelInput]="'Richiesta rinvio a giudizio'" [valueInput]="ctxBodyFascicolo.fascicolo.richiestaRinvioAGiudizio"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
         [labelInput]="'Richiesta oblazione'" [valueInput]="ctxBodyFascicolo.fascicolo.richiestaOblazione"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'boolean'"
         [labelInput]="'Opposizione archiviazione'" [valueInput]="ctxBodyFascicolo.fascicolo.opposizioneArchiviazione"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
         [labelInput]="'Data opposizione archiviazione'" [valueInput]="ctxBodyFascicolo.fascicolo.dataOpposizioneArchiviazione"></div>
  </fieldset>
 </div>
</div>
<!-- <div class="row container_fieldset">
 <div class="col-sm-12">
  <fieldset class="form-group">
    <legend>Prove</legend>
    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'boolean'"
         [labelInput]="'Sufficienza prove'" [valueInput]="ctxBodyFascicolo.fascicolo.sufficienzaProve"></div>
    <div class="col-sm-8 bloccodati">
      <p>
        <label for="prove" class="col-sm-8">Prove</label>
        <span class="longtext">{{ ctxBodyFascicolo.fascicolo.prove }}</span>
      </p>
    </div>
  </fieldset>
 </div>
</div> -->
<div class="row container_fieldset">
 <div class="col-sm-12">
  <fieldset class="form-group">
    <legend>Misure cautelari</legend>
    <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'boolean'"
         [labelInput]="'Misure cautelari'"
         [valueInput]="ctxBodyFascicolo.fascicolo.misureCautelari"></div>
    <div class="col-sm-10 bloccodati">
      <p>
        <label for="misura_adottata" class="col-sm-12" style="padding-left: 0px !important;">Misura adottata</label>
        <span class="longtext">{{ ctxBodyFascicolo.fascicolo.misuraAdottata }}</span>
      </p>
    </div>
  </fieldset>
 </div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
